import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ActionGuard, LoginGuard } from '../../core/_infrastructure/classes/guards/main.guard';
import { SolicitudCamWrapperComponent } from './datosbasicos/solicitud-cam-wrapper/solicitud-cam-wrapper.component';
import { SolicitudRecintoCamWrapperComponent } from './recintos/solicitud-recinto-cam-wrapper/solicitud-recinto-cam-wrapper.component';
import { ActionEstadoCamGuard } from '../../core/_infrastructure/classes/guards/campanias-guard';
import { EnumCodigosTwTcAcciones } from '../../_importacion/solicitudes/types/enum';
import { SolicitudDocumentacionWrapperComponent } from './documentacion/solicitud-documentacion-wrapper/solicitud-documentacion-wrapper.component';
import { SolicitudCamEnvioWrapperComponent } from './envio/solicitud-cam-envio-wrapper/solicitud-cam-envio-wrapper.component';
import { ValidacionAceptacionWrapperComponent } from './validacion-aceptacion/validacion-aceptacion-wrapper/validacion-aceptacion-wrapper.component';

const solicitudesCam: Routes = [
    {
        path: 'campanias/solicitud/datosbasicos',
        data: {
            breadcrumb: 'Solicitudes',
            menu0: 'Campañas',
            actionCode: EnumCodigosTwTcAcciones.MENU_DATOS_BAS_SOL_CAM,
            overridePath: 'campanias/solicitudes',
        },
        children: [
            {
                path: 'detail/:id',
                component: SolicitudCamWrapperComponent,
                canActivate: [LoginGuard(), ActionEstadoCamGuard()],
                data: {
                    breadcrumb: 'Detalle de la Solicitud de Campaña',
                    actionCode: EnumCodigosTwTcAcciones.MENU_DATOS_BAS_SOL_CAM,
                },
            },
            {
                path: 'create',
                component: SolicitudCamWrapperComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nueva Solicitud de Campaña',
                    actionCode: EnumCodigosTwTcAcciones.NEW_SOL_CAM,
                },
            },
        ],
    },
    {
        path: 'campanias/solicitud/recintos',
        data: {
            breadcrumb: 'Solicitudes',
            menu0: 'Campañas',
            actionCode: EnumCodigosTwTcAcciones.MENU_REC_PIA_SOL_CAM,
        },
        children: [
            {
                path: ':id',
                canActivate: [LoginGuard(), ActionEstadoCamGuard()],
                component: SolicitudRecintoCamWrapperComponent,
                data: {
                    breadcrumb: 'Recintos "PIAEd"',
                    actionCode: EnumCodigosTwTcAcciones.MENU_REC_PIA_SOL_CAM,
                },
            },
        ],
    },
    {
        path: 'campanias/solicitud/documentacion',
        data: {
            breadcrumb: 'Solicitudes',
            menu0: 'Campañas',
            actionCode: EnumCodigosTwTcAcciones.MENU_DOC_SOL_CAM,
        },
        children: [
            {
                path: ':id',
                canActivate: [LoginGuard(), ActionEstadoCamGuard()],
                component: SolicitudDocumentacionWrapperComponent,
                data: {
                    breadcrumb: 'Documentación',
                    actionCode: EnumCodigosTwTcAcciones.MENU_DOC_SOL_CAM,
                },
            },
        ],
    },
    {
        path: 'campanias/solicitud/envio',
        data: {
            breadcrumb: 'Solicitudes',
            menu0: 'Campañas',
            actionCode: EnumCodigosTwTcAcciones.MENU_SEND_SOL_CAM,
        },
        children: [
            {
                path: ':id',
                canActivate: [LoginGuard(), ActionEstadoCamGuard()],
                component: SolicitudCamEnvioWrapperComponent,
                data: {
                    breadcrumb: 'Envío',
                    actionCode: EnumCodigosTwTcAcciones.MENU_SEND_SOL_CAM,
                },
            },
        ],
    },
    {
        path: 'campanias/solicitud/validacion',
        data: {
            breadcrumb: 'Solicitudes',
            menu0: 'Campañas',
            actionCode: EnumCodigosTwTcAcciones.MENU_VAL_ACCEPT_SOL_CAM,
        },
        children: [
            {
                path: ':id',
                canActivate: [LoginGuard(), ActionEstadoCamGuard()],
                component: ValidacionAceptacionWrapperComponent,
                data: {
                    breadcrumb: 'Validación - Aceptación',
                    actionCode: EnumCodigosTwTcAcciones.MENU_VAL_ACCEPT_SOL_CAM,
                },
            },
        ],
    },
];
@NgModule({
    imports: [RouterModule.forChild(solicitudesCam)],
    exports: [RouterModule],
})
export class SolicitudesCamRoutingModule {}
